// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"36aaae46","184":"157f1dc0","394":"04c70b9f","464":"1c4e7e30","517":"2b1b7d0d","530":"05ae1354","727":"edc552be","825":"cd038cf2","860":"ceeaf118","935":"b62db664"}[chunkId] + ".chunk.js";
};